module.exports = __webpack_public_path__ + "img/ring_skip_0_0_1@2x.19368fba.png";